import { EventLandingPage } from "@/components/EventLandingPage";
import { MARVEL_EVENT } from "@/lib/marvelEvent";

export default function MarvelPage() {
  return <EventLandingPage event={MARVEL_EVENT} robots="noindex, follow" />;
}
